import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';
import { SharedLogic } from '../../../providers/component-logic/shared.logic';
import { GetCompanyData } from '../../../shared/nestjs/gd-only/dto/sf-company.dto';
import { EmployeesApi } from '../../../shared/nestjs/gd-only/services/employees.api';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import {
  DepartmentApi,
  InvitationMemberApi,
  RegistrationNewApi,
  SFChangeSpvApi,
  SunfishApi,
  TeodempcompanyApi,
  TeomemppersonalApi,
} from '../../../shared/sdk/services/custom';
import { SfChangeSpvApi } from '../../../shared/nestjs/gd-only/services/sf-change-spv.api';
import { map } from 'rxjs/operators';
import { SunfishNestApi } from '../../../shared/nestjs/gd-only/services/sunfish.api';
import { RequestInviteMember } from '../../../shared/nestjs/gd-only/dto/employees.dto';
import { ShiftDailyApi } from '../../../shared/nestjs/gd-only/services/shift-daily.api';
import { AuthApi } from '../../../shared/nestjs/gd-only/services/auth.api';
import { KioskApi } from '../../../shared/nestjs/gd-only/services/kiosk.api';
import { InvitationMemberNestApi } from '../../../shared/nestjs/gd-only/services/invitation-member';

@Injectable()
export class InviteMemberBloc {
  constructor(
    private storage: Storage,
    private sunfishApi: SunfishApi,
    private invitationMember: InvitationMemberApi,
    private registrationNewApi: RegistrationNewApi,
    private teodempcompanyApi: TeodempcompanyApi,
    private departmentApi: DepartmentApi,
    private nestApiProvider: NestApiProvider,
    private sharedLogic: SharedLogic,
    private teomemppersonalApi: TeomemppersonalApi,
    private sFChangeSpvApi: SFChangeSpvApi,
    private employeesApi: EmployeesApi,
    private invitationMemberApi: InvitationMemberApi,
    private sfChangeSpvApi: SfChangeSpvApi,
    private sunfishNestApi: SunfishNestApi,
    private shiftDailyApi: ShiftDailyApi,
    private authApi: AuthApi,
    private kioskApi: KioskApi,
    private invitationMemberNestApi: InvitationMemberNestApi,
  ) {
  }

  async getSFGoAuth(): Promise<any> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }

  getOrgStruct(empId: string): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.sunfishNestApi.getOrgStruct({ empId }).pipe(map(result => result.data))
          } else {
            return this.sunfishApi.getOrgStruct({ empId })
          }
        }
      )

  }

  findDataMember(payload: RequestFindDataMemberDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.invitationMemberNestApi.findDataMember(payload).pipe(map(result => result.data))
          } else {
            return this.invitationMember.findDataMember(payload).pipe(map(res => res[0]));
          }
        }
      )
  }

  getDataShiftGroup(): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.shiftDailyApi.getShiftPatterns().pipe(map(result => result.data))
          } else {
            return this.registrationNewApi.getDataShiftGroup();
          }
        }
      )
  }

  sendReinvitation(payload: any): Observable<any> {
    return this.invitationMemberNestApi.sendReinvitation(payload);
  }

  getTeodempcompany(payload1, payload2): Observable<any> {
    const stringifier1 = JSON.stringify(payload1);
    const stringifier2 = JSON.stringify(payload2);
    return this.teodempcompanyApi.SFfind(stringifier1, stringifier2);
  }

  getTeomemppersonal(payload1, payload2): Observable<any> {
    const stringifier1 = JSON.stringify(payload1);
    const stringifier2 = JSON.stringify(payload2);
    return this.teomemppersonalApi.SFfind(stringifier1, stringifier2);
  }

  checkEmail(email: string): Observable<any> {
    return this.employeesApi.findOne({ email })
  }

  checkEmpNo(empNo: string) {
    return this.kioskApi.getProfileByQrcode({ qrCode: empNo })
  }

  getOrganization(companyId: number | string): Observable<any> {
    return this.departmentApi.getOrganization({ companyId });
  }

  async getCompany(companyId: number): Promise<GetCompanyData> {
    return new Promise<GetCompanyData>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      try {
        if (isGoPathNewExist) {
          const result = await this.sharedLogic.getCompanyNest({ companyId });
          resolve(result.data)
        } else {
          const result = await this.sharedLogic.getCompanyLB({ companyId });
          resolve(result[0])
        }
      } catch (e) {
        reject(e);
      }
    })
  }

  isHRAdmin(): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.authApi.isHRAdmin().pipe(map(result => result.data))
          } else {
            return this.sunfishApi.isHRAdmin();
          }
        }
      )
  }

  getAllDataEmp(companyId: string) {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.sfChangeSpvApi.getAllDataEmp().pipe(map(result => result.data))
          } else {
            return this.sFChangeSpvApi.getAllDataEmp({ companyId });
          }
        }
      )
  }

  nested(arr, parent) {
    const newArr = [];
    for (const i in arr) {
      if (arr.hasOwnProperty(i)) {
        if (arr[i].parent == parent) {
          const childs = this.nested(arr, arr[i].id);

          arr[i] = {
            name: arr[i].title,
            role: arr[i].text,
            // photo: this.getPhotoUrl(arr[i].photo, arr[i].userId),
            // photo: '',
          };

          if (childs.length) {
            arr[i].childs = childs;
          } else {
            arr[i].childs = [];
          }

          newArr.push(arr[i]);
        }
      }
    }
    return newArr;
  }

  newEmployee(params): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(
        isGoPathNewExist => {
          if (isGoPathNewExist) {
            return this.employeesApi.newEmployee(params)
          } else {
            return this.invitationMemberApi.newEmployee(params)
          }
        }
      )
  }

  inviteMember(payload: RequestInviteMember) {
    return this.employeesApi.inviteMember(payload);
  }
}

export interface RequestFindDataMemberDto {
  empId: string;
  companyCode: string;
}

export interface ResendReinvitationDto {
  empId: string;
  email: string;
  oldEmail: string;
  phone: string;
  userId: string;
}

export interface RequestSendReinvitationDto {
  selectAll: boolean;
  data: ResendReinvitationDto[];
}


// WEBPACK FOOTER //
// ./src/bloc/hr/invite-member/invite-member.bloc.ts